import ErrorBoundary from "@/components/ErrorBoundary";
import Button from "@/components/Button";
import { useNavigate } from "@/router";

interface StudentNotFoundErrorBoundaryProps {
  universityId?: string;
}

export default function StudentNotFoundErrorBoundary({ universityId }: StudentNotFoundErrorBoundaryProps) {
  const navigate = useNavigate();

  const handleBackToStudents = () => {
    if (universityId) {
      navigate("/education/universities/:universityId/students/current", { params: { universityId } });
    } else {
      navigate("/education/universities");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6" data-testid="error">
      <ErrorBoundary
        title="Student Not Found"
        message="The student you're looking for could not be found. They may not be enrolled in this university's program or the student ID is invalid."
        image="default"
        variant="fullPage"
        action={
          <Button variant="filled" onClick={handleBackToStudents} testId="return-to-students-button">
            Return to Students
          </Button>
        }
      />
    </div>
  );
}
